import {
  Button,
  Col,
  DatePicker,
  Input,
  Pagination,
  Popover,
  Row, Skeleton, Table
} from "antd";
import { useEffect, useState } from "react";
import { FaEye, FaSearch } from "react-icons/fa";
import { MdTune } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useSelector } from "react-redux";
import { Get } from "../../config/api/get";
import { CARS } from "../../config/constants/api";
import { useDebouncedCallback } from "use-debounce";
import moment from "moment";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

const ExistingCarRequest = () => {
  dayjs.extend(timezone);
  dayjs.extend(utc);
  const token = useSelector((state) => state.user.userToken);
  const [loading, setLoading] = useState(false);
  const [cars , setCars] = useState(null);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [filter, setFilter] = useState({
    status: null,
    type: null,
    keyword: "",
    from: null,
    to: null,
  });
  const [paginationConfig, setPaginationConfig] = useState({
    pageNumber: 1,
    limit: 10,
    totalDocs: 0,
    totalPages: 0,
  });
  const getUsers = (pageNumber, pageSize, from, to, keyword) => {
    setLoading(true);
    Get(CARS.getAllCars, token, {
      from,
      to,
      keyword,
      status:"PENDING",
      page: pageNumber
        ? pageNumber.toString()
        : paginationConfig.pageNumber.toString(),
      limit: pageSize ? pageSize.toString() : paginationConfig.limit.toString(),
    })
      .then((response) => {
        if (response?.data?.docs) {
          setCars(response?.data?.docs);
          setPaginationConfig({
            pageNumber: response?.data?.page,
            limit: response?.data?.limit,
            totalDocs: response?.data?.totalDocs,
            totalPages: response?.data?.totalPages,
          });
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log("Error Fetching Loads", err);
        setLoading(false);
      });
  };
  useEffect(() => {
    getUsers();
    // eslint-disable-next-line
  }, []);
  const startIndex =
    (paginationConfig.pageNumber - 1) * paginationConfig.limit + 1;
  const endIndex = Math.min(
    startIndex + paginationConfig.limit - 1,
    paginationConfig.totalDocs
  );
  const message = cars
  ? `Showing records ${endIndex} of ${paginationConfig.totalDocs}`
  : "Showing records 0 of 0";


  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return (
        <button type="button" className="pagination-link">
          Previous
        </button>
      );
    }
    if (type === "next") {
      return (
        <button type="button" className="pagination-link">
          Next
        </button>
      );
    }
    return originalElement;
  };
  //   const filterContent = (
  //     <div className="filterDropdown">
  //       <div>
  //         <p className="mainLabel" style={{ padding: "10px" }}>
  //           Filter
  //         </p>
  //       </div>
  //       <hr style={{ margin: 0 }} />

  //       <div className="filterDropdownBody">
  //         <p className="mainLabel">Sort By:</p>
  //         <DatePicker
  //           className="mainInput filterInput"
  //           value={filter.from}
  //           onChange={(e) => handleFrom(e)}
  //         />
  //         <DatePicker
  //           className="mainInput filterInput"
  //           value={filter.to}
  //           onChange={(e) => handleTo(e)}
  //         />

  //         <p className="mainLabel">Filter by Status:</p>

  //         <Select
  //           size={"large"}
  //           className="filterSelectBox"
  //           placeholder="Select Status"
  //           value={filter.status}
  //           onChange={(e) => handleStatusChange(e)}
  //           style={{
  //             width: "100%",
  //             marginBottom: "10px",
  //             textAlign: "left",
  //           }}
  //           options={[
  //             { value: "ACTIVE", label: "Active" },
  //             { value: "INACTIVE", label: "Inactive" },
  //           ]}
  //         />

  //         <Button
  //           type="primary"
  //           shape="round"
  //           block
  //           size={"large"}
  //           style={{ marginBottom: "10px" }}
  //           className="mainButton primaryButton"
  //           onClick={() => getUsers()}
  //         >
  //           Apply
  //         </Button>
  //         <Button
  //           type="primary"
  //           shape="round"
  //           block
  //           size={"large"}
  //           className="mainButton primaryButton2"
  //           onClick={() => resetFilter()}
  //         >
  //           Clear All
  //         </Button>
  //       </div>
  //     </div>
  //   );
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const handlePageChange = (pageNumber) => {
    setPaginationConfig({
      ...paginationConfig,
      pageNumber: pageNumber,
    });
    getUsers(pageNumber, paginationConfig.limit);
  };

  const handleSearch = useDebouncedCallback((value) => {
    setFilter({
      ...filter,
      keyword: value,
    });
    getUsers(
      paginationConfig.pageNumber,
      paginationConfig.limit,
      null,
      null,
      null,
      value
    );
  }, 1000);
  const handleFrom = (date) => {
    setFilter({
      ...filter,
      from: date,
    });
  };

  const handleTo = (date) => {
    setFilter({
      ...filter,
      to: date,
    });
  };
  const data = {
    status: filter.status,
    keyword: filter.keyword,
    from: filter.from,
    to: filter.to,
  };
  const handleApply = () => {
    let from;
    let to;
    if (data.from) {
      from = moment(filter?.from?.$d).format("YYYY-MM-DD");
    }
    if (data.to) {
      to = moment(filter?.to?.$d).format("YYYY-MM-DD");
    }
    if (from || to ) {
      getUsers(
        paginationConfig.pageNumber,
        paginationConfig.limit,
        from,
        to,
      );
    } else {
      return;
    }
  };
  const resetFilter = () => {
    setFilter({
      status: null,
      keyword: "",
      from: null,
      to: null,
    });
  };
  const handleClear = () => {
    resetFilter();
    getUsers();
  };
  const filterContent = (
    <div className="filterDropdown">
      <div>
        <p
          className="mainLabel"
          style={{ padding: "10px", fontSize: "18px", fontWeight: "bold" }}
        >
          Filter
        </p>
      </div>
      <hr style={{ marginBottom: 10 }} />

      <div className="filterDropdownBody">
        <p className="mainLabel">From:</p>
        <DatePicker
          className="mainInput filterInput web-input"
          value={filter.from}
          onChange={(e) => handleFrom(e)}
          style={{ width: "100%" }}
        />
        <p className="mainLabel">To:</p>
        <DatePicker
          className="mainInput filterInput web-input"
          value={filter.to}
          onChange={(e) => handleTo(e)}
          style={{ width: "100%" }}
        />
        <Button
          type=""
          block
          size={"large"}
          style={{ marginBottom: "10px" }}
          className="web-btn"
          //   onClick={() => getUsers()}
          onClick={handleApply}
        >
          Apply
        </Button>
        <Button
          type=""
          block
          size={"large"}
          className="web-btn"
          onClick={handleClear}
        >
          Clear All
        </Button>
      </div>
    </div>
  );
  const columns = [
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          S.NO
        </p>
      ),
      dataIndex: "key",
      key: "key",
      render: (value, item, index) => (
        <p className="text-xs text-center font-euclid text-[#575757]">
          {(index < 10 && "0") + (index + 1)}
        </p>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          Car Name
        </p>
      ),
      dataIndex: "carName",
      key: "carName",
      render: (value, item, index) => (
        <p className="text-xs text-center font-euclid text-[#575757]">
           {item.name}
        </p>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
           Chauffeur Name
        </p>
      ),
      dataIndex: ["chauffeur","name"],
      key: "driverName",
      render: (value, item, index) => (
        <p className="text-xs text-center font-euclid text-[#575757]">
      {item?.chauffeur?.firstName} {item?.chauffeur?.lastName}
        </p>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          Car Model
        </p>
      ),
      dataIndex: "carModel",
      key: "carModel",
      render: (value, item, index) => (
        <p className="text-xs text-center font-euclid text-[#575757]">
            {item.model}
        </p>
      ),
    },

    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          Car number
        </p>
      ),
      dataIndex: "carNumber",
      key: "carNumber",
      render: (value, item, index) => (
        <p className="text-xs text-center font-euclid text-[#575757]">
          {item.carNumber}
        </p>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          registeration date
        </p>
      ),
      dataIndex: "createdAt",
      key: "createdAt",
      render: (item) => <span>{dayjs.tz(item, "UTC").format("M/D/YYYY")}</span>,
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          Status
        </p>
      ),
      dataIndex: "status",
      key: "status",
      render: (value, item, index) => (
        <p
          className={`text-xs text-center font-euclid text-[#575757] ${
            item.status.toLowerCase() === "pending"
              ? "text-[#F26B1F]"
              : "text-[#E0010A]"
          }`}
        >
          {item.status}
        </p>
      ),
    },
    {
      title: (
        <p className="uppercase font-euclid text-black font-bold text-xs text-center">
          action
        </p>
      ),
      dataIndex: "_id",
      key: "_id",
      render: (value, item) => (
        <div className="flex justify-center">
          <div className="flex justify-center bg-[#FDE6C3] rounded-[100%] w-fit p-2 mr-1">
            <FaEye
              className="text-[#CD810D] cursor-pointer h-[16px] w-[16px]"
              onClick={() => navigate("/carDetails/" + item._id, {state : {showButtons : true}})}
            />
          </div>
        </div>
      ),
    },
  ];
  return (
    <Row justify="center">
      <Col md={23} xs={22}>
        <div className="flex justify-between items-center my-8">
          <div className="flex justify-center items-center">
            <IoIosArrowRoundBack
              onClick={() => navigate(-1)}
              className="self-center cursor-pointer mr-1 w-[48px] h-[48px] max-sm:w-[24px] max-sm:h-[24px] text-black"
            />
            <h3 className="font-tavi laptop:text-3xl text-lg font-normal text-black">
              Car Request
            </h3>
          </div>

          <div className="flex justify-center items-center">
            <div className=" w-[250px] max-md:w-[120px]">
              <Input
                className="mainInput dashInput h-full"
                placeholder="Search"
                  onChange={(e) => handleSearch(e.target.value)}
                suffix={
                  <FaSearch
                    style={{
                      color: "#818181",
                      fontSize: 16,
                      cursor: "pointer",
                    }}
                    //   onClick={() =>
                    //     getUsers(1, paginationConfig.limit, filter.keyword)
                    //   }
                  />
                }
                //   onPressEnter={(e) =>
                //     getUsers(1, paginationConfig.limit, filter.keyword)
                //   }
              />
            </div>
            &emsp;
            <div className="flex justify-center">
              <Popover
                  content={filterContent}
                trigger="click"
                  open={open}
                  onOpenChange={handleOpenChange}
                placement="bottomRight"
                arrow={false}
              >
                <Button
                  style={{
                    padding: "4px 11px",
                    height: "auto",
                    borderRadius: "6px",
                    backgroundColor: "white",
                  }}
                >
                  <MdTune className="max-xl:text-[24px] text-[32px] text-[#767676]" />
                </Button>
              </Popover>
            </div>
          </div>
        </div>
        <div
          className="bg-white rounded-lg  py-8 my-8"
          style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
        >
          <Row style={{ overflow: "auto" }} className="px-6">
            {loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Skeleton active />
                <br />
              </div>
            ) : (
              <Table
                className="styledTable"
                dataSource={cars}
                columns={columns}
                pagination={false}
              />
            )}
          </Row>
          <Row style={{ padding: "10px 20px" }}>
            <Col xs={24} md={12}>
              <p className="font-euclid text-sm text-black">{message}</p>
            </Col>
            <Col
              xs={24}
              md={12}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Pagination
                className="styledPagination"
                onChange={(e) => handlePageChange(e)}
                current={parseInt(paginationConfig.pageNumber)}
                pageSize={paginationConfig.limit}
                total={paginationConfig.totalDocs}
                itemRender={itemRender}
              />
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default ExistingCarRequest;
